import React from 'react';
import BeerCards from './BeerCards';

export default function Beers() {
  return (
    <div
      id='beers'
      style={{
        height: 'fit-content',
        backgroundColor: 'black',
        overflow: 'visible',
        zIndex: 10,
        position: 'relative',
      }}
    >
      <BeerCards />
    </div>
  );
}
